<template>
  <div class="p-md-3 w-100">
    <div class="row pb-md-2 pb-3 pt-0">
      <div class="col-md-7 d-flex justify-content-start align-items-center">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb p-0 m-0">
            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
            <li class="breadcrumb-item" aria-current="page"> <router-link to="../my-orders">Orders</router-link></li>
            <li class="breadcrumb-item active" aria-current="page"> {{ selectedOrderNumber ? selectedOrderNumber : wooOrderDetails.number }}</li>
          </ol>
        </nav>
      </div>
      <div class="col-md-5">
        <div class="row mt-2">
          <div class="col-md-4 mb-2">
            <button type="button" class="btn btn-secondary me-2 w-100" style="height: 45px"
              :disabled="shipstationOrderDetails && trackingNumber"
              @click="confirmCancelOrder()">
              <i class="fa-duotone fa-solid fa-ban me-1"></i> Cancel Order
            </button>
          </div>
          <div class="col-md-4 mb-2" v-if="shipstationOrderDetails && wooOrderDetails">
            <button type="button" class="btn btn-dark me-2 w-100" style="height: 45px"
              :disabled="shipstationOrderDetails.shipments.length == 0"
              @click="printReturnShippingLabel(wooOrderDetails, shipstationOrderDetails.shipments[0])">
                <i class="fa-duotone fa-solid fa-print me-1"></i> Return Label
            </button>
          </div>
          <div class="col-md-4">
            <button type="button" class="btn btn-success me-2 w-100" style="height: 45px"
            @click="refreshOrder">
              <i class="fa-duotone fa-solid fa-rotate-right me-2"></i> Refresh Order</button>
          </div>
        </div>
        <!-- <a target="_blank" :href="shippingTrackingUrl+trackingNumber" v-if="trackingNumber" class="d-none">
          <button type="button" class="btn text-white fw-bold d-flex align-items-center" :style="'background-color:'+shipmentColor">
            <img :src="shippingLogo" style="height: 14px;" class="me-2" />
            {{ trackingNumber}}
          </button>
        </a> -->
      </div>
    </div>


    <div class="row">
      <div class="col-md-5">
        <div class="card">
          <div class="d-flex card-header justify-content-start align-items-center">
            <h4 class="header-title">Whats in the box</h4>
          </div>
          <div class="card-body">
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex align-items-center mb-3 p-0" v-for="item in lineItems" :key="item.id">
                <div class="row w-100 p-0 m-0">
                  <div class="col-3 text-center">
                    <img :src="item.image.src" class="w-100" style="max-height: 100px; max-width: 100px;"/>
                  </div>
                  <div class="col-9">
                    <h5 class="mb-2">{{ item.name }}</h5>
                    <div v-for="meta in wooOrderDetails.meta_data" :key="meta.id">
                      <div v-if="meta.key == 'vin'">
                        <span class="text-muted" style="font-weight: 600; font-size: 13px;" v-if="meta.value != appConstants.PROVIDE_VIN_LATER && meta.value">
                          <i class="fa-duotone fa-solid fa-circle-check me-2 text-success"></i> Provided VIN: {{ meta.value }}
                        </span>
                        <div v-else class="alert alert-warning d-flex justify-content-between align-items-center" role="alert" style="font-weight: 500; font-size: 13px;">
                          <span class="text-muted">Your VIN is Required!</span>
                          <button type="button" class="btn btn-warning" style="font-size: 11px; max-height: 30px !important" @click="openVinModal(item.sku)">Provide VIN</button>
                        </div>
                      </div>
                    </div>
                    <!-- Check if VIN meta doesn't exist -->
                    <div 
                      v-if="this.wooOrderDetails.order_status == appConstants.ORDER_STATUS.VIN_REQUIRED" 
                      class="alert alert-warning d-flex justify-content-between align-items-center" 
                      role="alert" 
                      style="font-weight: 500; font-size: 13px;"
                    >
                      <span class="text-muted">Your VIN is Required!</span>
                      <button 
                        type="button" 
                        class="btn btn-warning" 
                        style="font-size: 11px; max-height: 30px !important" 
                        @click="openVinModal(item.sku)"
                      >
                        Provide VIN
                      </button>
                    </div>
                    <div v-for="addon in item.addOns" :key="addon.name">
                      <span class="text-muted" style="font-weight: 600; font-size: 13px;" v-if="addon.name == appConstants.RVC_TITLE && addon.value">
                        <i class="fa-duotone fa-solid fa-circle-check me-2 text-success"></i> Provided VIN: {{ addon.value }}
                      </span>
                      <div v-else class="alert alert-warning d-flex justify-content-between align-items-center" role="alert" style="font-weight: 500; font-size: 13px;">
                        <span class="text-muted">Your VIN is Required!</span>
                        <button type="button" class="btn btn-warning" style="font-size: 11px; max-height: 30px !important" @click="openVinModal(item.sku)">Provide VIN</button>
                      </div>
                    </div>
                    <div v-if="item.addOns" class="w-100">
                      <ul class="list-group list-group-flush mt-3" v-if="item.addOns.length">
                        <li class="list-group-item ps-0">Your Add ons: <span>({{ item.addOns.length }})</span></li>
                        <li class="list-group-item ps-0 d-flex justify-cotent-between" v-for="addon in item.addOns" :key="addon.name">
                          <img :src="'http://makspartnerprogram.com/wp-content/uploads/2024/08/'+addon.id+'.webp'" style="height:20px" class="me-2"/>{{ addon.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- <div class="col-md-2">
                    <h5 class="text-center d-flex"><span class="d-md-none d-block me-2">Quantity:</span> {{ item.quantity }}</h5>
                  </div> -->
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="card">
          <div class="d-flex card-header justify-content-start align-items-center">
            <h4 class="header-title">Order Totals</h4>
          </div>
          <div class="card-body">
            <table class="table" v-if="wooOrderDetails">
              <tbody>
                <tr v-if="wooOrderDetails.coupon_lines.length">
                  <th scope="row">Discount Codes:</th>
                  <td>
                    <span class="badge rounded-pill bg-primary me-1" v-for="coupon in wooOrderDetails.coupon_lines" :key="coupon.id">
                      {{ coupon.code }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Discount:</th>
                  <td>${{ wooOrderDetails.discount_total }}</td>
                </tr>
                <tr>
                  <th scope="row">Shipping Cost:</th>
                  <td>${{ wooOrderDetails.shipping_total }}</td>
                </tr>
                <tr v-for="fees in wooOrderDetails.fee_lines" :key="fees.id">
                  <th scope="row">{{ fees.name }}:</th>
                  <td>${{ fees.total }}</td>
                </tr>
                <tr>
                  <th scope="row">Total:</th>
                  <td>${{ wooOrderDetails.total }}</td>
                </tr>
                <tr v-for="refund in wooOrderDetails.refunds" :key="refund.id">
                  <th scope="row">Refund {{ refund.id }}:</th>
                  <td>${{ refund.total }}</td>
                </tr>
                <tr v-if="wooOrderDetails.total_after_refund">
                  <th scope="row">Net Payment:</th>
                  <td>${{ wooOrderDetails.total_after_refund }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="d-flex card-header justify-content-start align-items-center">
            <h4 class="header-title">Orders Details</h4>
          </div>
          <div class="card-body mt-0 pt-0">
            <table class="table" v-if="wooOrderDetails">
              <tbody>
                <tr>
                  <th scope="row">Order Number:</th>
                  <td>{{ wooOrderDetails.number }}</td>
                </tr>
                <tr>
                  <th scope="row" class="d-md-block d-none">Date Placed:</th>
                  <td scope="row" colspan="2">
                    <p class="fw-bold d-md-none d-block">Date Placed:</p>
                    {{ moment(wooOrderDetails.date_created).format('LLL') }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="d-md-block d-none">Placed By:</th>
                  <td scope="row" colspan="2">
                    <p class="fw-bold d-md-none d-block">Placed By:</p>
                    {{ wooOrderDetails.billing.first_name }} {{ wooOrderDetails.billing.last_name }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="d-md-block d-none">Email:</th>
                  <td scope="row" colspan="2">
                    <p class="fw-bold d-md-none d-block">Email:</p>
                    {{ wooOrderDetails.billing.email }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" class="d-md-block d-none">Phone Number:</th>
                  <td scope="row" colspan="2">
                    <p class="fw-bold d-md-none d-block">Phone Number:</p>
                    {{ wooOrderDetails.billing.phone }}
                  </td>
                </tr>
                <tr v-if="wooOrderDetails.payment_method_title">
                  <th scope="row" class="d-md-block d-none">Payment Method:</th>
                  <td scope="row" colspan="2">
                    <p class="fw-bold d-md-none d-block">Payment Method:</p>
                    {{ wooOrderDetails.payment_method_title }}
                  </td>
                </tr>
                <tr v-if="orderVin">
                  <th scope="row">Provided VIN:</th>
                  <td>{{ orderVin }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card">
          <div class="d-flex card-header justify-content-between align-items-center" :style="'background-color:'+shipmentColor">
            <h4 class="header-title text-white">Shipment Details</h4>
            <img :src="shippingLogo" style="height: 30px"/>
          </div>
          <div class="card-body mt-0 pt-0">
            <table class="table" v-if="wooOrderDetails">
              <tbody>
                <tr v-for="sl in wooOrderDetails.shipping_lines" :key="sl.id">
                  <td scope="row" colspan="2">{{ sl.method_title }}</td>
                </tr>
                <tr v-if="trackingNumber">
                  <th scope="row" class="d-md-block d-none">Tracking Number:</th>
                  <td scope="row" colspan="2">
                    <p class="fw-bold d-md-none d-block">Tracking Number:</p>
                    <a target="_blank" :href="shippingTrackingUrl+trackingNumber" class="text-primary">{{ trackingNumber }}</a>
                  </td>
                </tr>
                <tr v-if="wooOrderDetails.billing.address_1 === wooOrderDetails.shipping.address_1">
                  <td scope="row" colspan="2">
                    <p class="fw-bold">Billing
                      <span v-if="wooOrderDetails.billing.address_1 === wooOrderDetails.shipping.address_1">& Shipping</span>
                      <span v-else>Information</span>
                    </p>
                    {{ wooOrderDetails.billing.first_name }} {{ wooOrderDetails.billing.last_name }} <br/>
                    {{ wooOrderDetails.billing.address_1 }}, {{ wooOrderDetails.billing.city }}, {{ wooOrderDetails.billing.state }} {{ wooOrderDetails.billing.postcode }}, {{ wooOrderDetails.billing.country }}
                  </td>
                </tr>
                <tr v-if="wooOrderDetails.billing.address_1 != wooOrderDetails.shipping.address_1">
                  <td scope="row" colspan="2">
                    <p class="fw-bold">Shipping Information</p>
                    {{ wooOrderDetails.shipping.first_name }} {{ wooOrderDetails.shipping.last_name }} <br/>
                    {{ wooOrderDetails.shipping.address_1 }}, {{ wooOrderDetails.shipping.city }}, {{ wooOrderDetails.shipping.state }} {{ wooOrderDetails.shipping.postcode }}, {{ wooOrderDetails.shipping.country }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card">
          <div class="d-flex card-header justify-content-end align-items-center">
          </div>
          <div class="card-body mt-0 pt-0">
            <div class="timeline">
              <div v-for="timeline in timelineData" :key="timeline.status">
                <div :class="'timeline-container '+(timeline.defaultClass ? timeline.defaultClass : 'secondary')" v-if="timeline.isHidden == false">
                    <div class="timeline-icon" :class="(!timeline.isActive? 'opacity-50' : '') + ' '+(timeline.isCurrent ? 'pulse' : '')">
                      <i :class="timeline.icon" style="font-size: 20px;"></i>
                    </div>
                    <div :class="'timeline-body p-2 pb-1 bg-'+timeline.defaultClass+'-subtle '">
                      <div :class="(!timeline.isActive? 'opacity-50' : '')">
                        <h4 class="timeline-title"><span class="badge">{{ timeline.statusTitle }}</span></h4>
                        <p>{{ timeline.statusSubtitle }}</p>
                        <p class="timeline-subtitle" v-if="timeline.date">{{ timeline.date }}</p>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProvideVinModalComponent
      :isOpen="isModalOpen"
      :modalTitle="'Enter Your VIN Here'"
      :vinLength="17"
      :orderNumber="wooOrderDetails.number ? wooOrderDetails.number: selectedOrderNumber"
      :orderId="selectedOrderId"
      :orderSKU="selectedSku"
      :vinProvided="isVinProvided"
      :vinPlaceholder="'Please enter your 17-digit VIN'"
      @update:isOpen="updateModalOpen"
      @update:vinProvided="setStatusProcessing"
    />
  </div>
</template>

<script lang="js">
import { defineComponent } from 'vue'
//import UnderConstruction from '../components/UnderConstruction';
import Mixin from '../mixins/global.mixin'
import { useRouter } from 'vue-router'
import { mapState } from 'vuex'
import appConstants from '@/constants/app.constants';
import store from '../store'
import axios from 'axios';
import moment from 'moment'
import fedexLogo from '../assets/fedex_logo_white.png'
import ProvideVinModalComponent from '../components/ProvideVinModalComponent';
import Swal from 'sweetalert2';

export default defineComponent({
  name: 'OrderDetails',
  components: {
    ProvideVinModalComponent
  },
  mixins: [Mixin],
  setup() {
    return {
      useRouter: useRouter(),
      fedexLogo: fedexLogo,
      moment: moment,
      storeId: appConstants.CURRENT_STOREID
    }
  },
  data () {
    return {
      appConstants: appConstants,
      loadedOrderDetails: [],
      selectedOrderNumber: null,
      selectedOrderId: null,
      selectedSku: null,
      wooOrderDetails: null,
      shipstationOrderDetails: null,
      lineItems: [],
      isModalOpen: false,
      isVinProvided: [],
      timelineData: [],
      orderVin: null,
      trackingNumber: null,
      shippingCourier: null,
      shippingLogo: null,
      shipmentColor: appConstants.STAMPS_COM_COLOR
    }
  },
  computed: mapState([
    'currentSessionEmail',
    'fedexAccessToken',
    'orderListStorage',
    'currentOrderDetails',
    'currentShipstationDetails',
    'providedVins'
  ]),
  watch: {
    wooOrderDetails: function (newVal) {
      if (newVal) {
        var isForPickUp = Object.values(newVal.shipping_lines).filter( (sl) => sl.method_id == 'local_pickup').length ? true : false;
        newVal.sku = [];
        newVal.isForPickUp = isForPickUp;
        newVal.total_after_refund = 0;
        newVal.live_status_update = null;
        newVal.payment_method_title = newVal.payment_method_title.replace('&amp;','&');
        let refund_total = 0;

        if (newVal.refunds.length) {
          newVal.refunds.forEach((refund, idx, array) => {
            refund_total = refund_total + parseFloat(refund.total);
            if (idx+1 == array.length) {
              newVal.total_after_refund = (parseFloat(newVal.total) + parseFloat(refund_total)).toFixed(2);
            }
          });
        }

        let shippingLinesText = null;
        if (newVal.shipping_lines.forEach((sl, idx, array) => {
          shippingLinesText = shippingLinesText + sl.method_title;
          if (idx+1 == array.length) {
            switch (true) {
              case (shippingLinesText.toLowerCase().includes('fedex')):
                this.shippingLogo = appConstants.FEDEX_LOGO;
                this.shipmentColor = appConstants.FEDEX_COLOR;
                break;
              case (shippingLinesText.toLowerCase().includes('usps')):
                this.shippingLogo = appConstants.STAMPS_COM_LOGO;
                this.shipmentColor = appConstants.STAMPS_COM_COLOR;
                break;
              case (shippingLinesText.toLowerCase().includes('dhl')):
                this.shippingLogo = appConstants.DHL_LOGO;
                this.shipmentColor = appConstants.DHL_COLOR;
                break;
            }
          }
        }));

        
        switch (newVal.status) {
          case appConstants.ORDER_STATUS.PROCESSING.toLocaleLowerCase():
            var vin = newVal.meta_data.filter((meta) => meta.key === 'vin');
            if (vin.length) {
              if (vin[0].value == appConstants.PROVIDE_VIN_LATER) {
                newVal.order_status = appConstants.ORDER_STATUS.VIN_REQUIRED
              } else {
                newVal.order_status = appConstants.ORDER_STATUS.PROCESSING
              }
            } else {
              newVal.order_status = appConstants.ORDER_STATUS.VIN_REQUIRED
            }
            break;
          case appConstants.ORDER_STATUS.COMPLETED.toLocaleLowerCase():
            newVal.order_status = appConstants.ORDER_STATUS.COMPLETED;
            if (newVal.total_after_refund && !this.shipstationOrderDetails.shipments.length) {
              newVal.order_status = appConstants.ORDER_STATUS.REFUNDED;
            } else if (moment().diff(newVal.date_completed, 'days') > 30) {
              newVal.order_status = appConstants.ORDER_STATUS.DELIVERED;
            }
            break;
          case appConstants.ORDER_STATUS.FAILED.toLocaleLowerCase():
            newVal.order_status = appConstants.ORDER_STATUS.FAILED;
            break;
          case appConstants.ORDER_STATUS.CANCELLED.toLocaleLowerCase():
            newVal.order_status = appConstants.ORDER_STATUS.CANCELLED;
            break;
          case appConstants.ORDER_STATUS.ON_HOLD.toLocaleLowerCase():
            newVal.order_status = appConstants.ORDER_STATUS.ON_HOLD;
            break;
        }
        

        newVal.line_items.forEach((item, idx, array) => {
          newVal.sku.push(item.sku);
          item.addOns = [];
          // item.meta_data.forEach((meta) => {
          //   if (meta && meta.key == '_tmcartepo_data') {
          //     meta.value.forEach((epo, idx, array) => {
          //       var isRVCPurchased = false;
          //       var isVINGiven = false;
          //       var vinProvided = null;

          //       switch(epo.cssclass) {
          //         case appConstants.VEHICLE_CONFIG_META:
          //           if (epo.value == 'Purchase') {
          //             isRVCPurchased = true;
          //           }
          //           break;
          //         case appConstants.VIN_META:
          //           if (epo.value != appConstants.PROVIDE_VIN_LATER) {
          //             isVINGiven = true;
          //           }
          //           break;
          //         case appConstants.COLORED_LID_META:
          //           if (epo.value.toLowerCase() != 'Black') {
          //             item.addOns.push({
          //               'id': epo.value.toLowerCase(),
          //               'name': appConstants.LID_TITLE,
          //               'value': epo.value,
          //               'price': appConstants.COLORED_LID_PRICE
          //             });
          //           }
          //           break;
          //       }
          //       if (idx+1 == array.length) {
          //         let tracker = [];
          //         if (this.providedVins.total_count) {
          //           tracker = this.providedVins.vin_trackers.filter((vin) => vin.message.includes(item.sku));
          //         }
          //         if (tracker.length) {
          //           this.orderVin = tracker[0].vin;
          //           item.vin = tracker[0].vin;
          //           vinProvided = tracker[0].vin;
          //           isVINGiven = true;
          //         }


          //         if (isRVCPurchased) {
          //           item.addOns.push({
          //             'id': epo.cssclass,
          //             'name': appConstants.RVC_TITLE,
          //             'value': vinProvided,
          //             'price': appConstants.RVC_PRICE,
          //           });
          //         }
          //         if (isRVCPurchased && !isVINGiven) {
          //           item.isVINRequired = true;
          //           if (appConstants.ORDER_STATUS.PROCESSING.toLocaleLowerCase() == newVal.status) {
          //             newVal.order_status = appConstants.ORDER_STATUS.VIN_REQUIRED;
          //           }
          //         } else {
          //           item.isVINRequired = false;
          //           if (appConstants.ORDER_STATUS.PROCESSING.toLocaleLowerCase() == newVal.status) {
          //             newVal.order_status = appConstants.ORDER_STATUS.PROCESSING;
          //           }
          //         }
          //       }
          //     });
          //   }
          // });
          this.lineItems.push(item);
          if (idx+1 == array.length) {
            this.generateTimelineData(newVal, newVal.order_status);
          }
        });


      }
    },
    shipstationOrderDetails: function (newVal) {
      if (newVal.shipments.length) {
        var stamps_com = newVal.shipments.filter((stamp) => stamp.carrierCode == 'stamps_com');
        var fedex = newVal.shipments.filter((fdx) => fdx.carrierCode == 'fedex');
        var dhl = newVal.shipments.filter((dhl) =>  dhl.carrierCode.includes('dhl'));
        switch (true) {
          case (fedex.length > 0):
            this.shippingCourier = appConstants.FEDEX_CARRIER_CODE;
            this.shippingTrackingUrl = appConstants.FEDEX_TRACKING_BASE_URL;
            this.getFedexTrackingInfo(fedex[0].trackingNumber);
            break;
          case (dhl.length > 0):
            this.shippingCourier = appConstants.DHL_CARRIER_CODE;
            this.shippingTrackingUrl = appConstants.DHL_TRACKING_BASE_URL;
            this.getStampsTrackingInfo(dhl[0].trackingNumber);
            break;
          case (stamps_com.length > 0):
            this.shippingCourier = appConstants.STAMPS_COM_CARRIER_CODE;
            this.shippingTrackingUrl = appConstants.USPS_TRACKING_BASE_URL;
            this.getStampsTrackingInfo(stamps_com[0].trackingNumber);
            break;
        }
      }

    }
  },
  methods: {
    confirmCancelOrder: function () {
      Swal.fire({
        title: "Feature Under Development",
        html: 'You may contact our customer support for order cancellations',
        showDenyButton: false,
        icon: 'warning',
        confirmButtonText: "Contact Support",
        customClass: {
          confirmButton: 'bg-primary',
        },
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          window.open("tel:+18187985558");
        }
      });
    },
    generateTimelineData: function (order, currentStatus) {
      this.timelineData = appConstants.TIMELINE_OBJECT;
      var currentStep = 0;
      var currentStepId = 0;
      var currentStepItem = this.timelineData.filter((tld) => tld.status == currentStatus);
      if (currentStepItem.length) {
        currentStepId = currentStepItem[0].id;
        currentStep = currentStepItem[0].step_id;
      }

      if (!order.isForPickUp) {
        this.timelineData = this.timelineData.filter((tld) => tld.status != appConstants.ORDER_STATUS.READY_FOR_PICK_UP);
      }
      if (!order.refunds.length) {
        this.timelineData = this.timelineData.filter((tld) => tld.status != appConstants.ORDER_STATUS.REFUNDED);
      }

      this.timelineData.forEach((tl) => {
        if (tl.status == appConstants.ORDER_STATUS.CREATED && order.date_created) {
          tl.date = moment(order.date_created).format('LL');
        }

        if (tl.status == appConstants.ORDER_STATUS.COMPLETED && order.date_completed) {
          tl.date = moment(order.date_completed).format('LL');
        }

        if (tl.status == appConstants.ORDER_STATUS.DELIVERED && order.date_delivered) {
          tl.date = moment(order.date_delivered).format('LL');
        }

        switch (true) {
          case (tl.step_id < currentStep):
            if (!tl.defaultClass) {
              tl.defaultClass = 'success';
            }
            tl.isActive = true;
            tl.isCurrent = false;
            if (
              tl.status == appConstants.ORDER_STATUS.VIN_REQUIRED ||
              tl.status == appConstants.ORDER_STATUS.CANCELLED || 
              tl.status == appConstants.ORDER_STATUS.FAILED ||
              tl.status == appConstants.ORDER_STATUS.ON_HOLD
            ) {
              tl.isHidden = true;
            }

            break;
          case (tl.step_id == currentStep && currentStepId == tl.id):
            if (!tl.defaultClass) {
              tl.defaultClass = 'success';
            }
            tl.isHidden = false;
            tl.isActive = true;
            tl.isCurrent = true;
            break;
          case (tl.step_id == currentStep && currentStepId != tl.id):
            tl.isHidden = true;
            tl.isActive = false;
            tl.isCurrent = false;
            break;
          case (tl.step_id > currentStep):
            if (!tl.defaultClass || tl.defaultClass == 'success') {
              tl.defaultClass = '';
            }
            tl.isActive = false;
            tl.isCurrent = false;
            break;
        }
      });
    },
    getOrderDetails: async function (orderId) {
      try {
        var results = await Promise.all([this.getWoocommerceOrderDetails(orderId)]);
        if (!this.selectedOrderNumber) {
          this.selectedOrderNumber = results[0].number;
        }
        const results2 = await Promise.all([this.getShipstationOrderDetails(this.selectedOrderNumber), this.getProvidedVins(orderId)]);
        results = results.concat(results2);
        await this.afterComplete(results);
      } catch (error) {
        console.error('Error running functions:', error);
      }
    },
    openVinModal: function (sku) {
      this.selectedSku = sku;
      this.updateModalOpen(true);
    },
    updateModalOpen: function (value) {
      this.isModalOpen = value;
    },
    setStatusProcessing: function (value) {
      var item2 = this.currentOrderDetails.meta_data.find(meta => meta.key === "vin");
      if (item2) {
          item2.value = value;
      }
      var item = this.wooOrderDetails.meta_data.find(meta => meta.key === "vin");
      if (item) {
          item.value = value;
      }
      this.generateTimelineData(this.wooOrderDetails, appConstants.ORDER_STATUS.PROCESSING);
      this.isVinProvided = value;
      console.log(value);
    },
    getWoocommerceOrderDetails: async function (orderId) {
      let response = await axios.get(appConstants.SITEURL+'/wp-json/wc/v3/orders/'+orderId, { headers : {'Authorization': appConstants.SITEAUTH}});
      return response.data;
    },
    getShipstationOrderDetails: async function (order_number) {
      let response = await axios.get(appConstants.SHIPSTATION_BASE_URL+'shipments?orderNumber='+order_number,
        {
          headers: {
            Authorization: appConstants.SHIPSTATION_AUTH,
          },
        }
      );
      return response.data;
    },
    getProvidedVins: async function (orderId) {
      let response = await axios.get(appConstants.SERVICESURL+'/api/v1/vin_trackers?site='+(appConstants.SITEURL.toLowerCase().includes('tipm') ? 'tipm' : 'ecm')+'&order_number='+orderId)
      return response.data;
    },
    refreshOrder: function () {
      store.commit('SET_CURRENT_ORDER_DETAILS', null);
      store.commit('SET_CURRENT_SHIPSTATION_DETAILS', null);
      store.commit('SET_PROVIDED_VIN', []);
      this.lineItems = [];
      this.getOrderDetails(this.selectedOrderId);
      console.log('refreshing order');
      this.toggleFullScreenSpinner(true);
    },
    afterComplete: function (results) {
      this.timelineData = [];
      this.toggleFullScreenSpinner(false);
      if (results[0] && results[1] && results[2]) {
        store.commit('SET_CURRENT_ORDER_DETAILS', results[0]);
        store.commit('SET_CURRENT_SHIPSTATION_DETAILS', results[1]);
        store.commit('SET_PROVIDED_VIN', results[2]);
        this.timelineData = appConstants.TIMELINE_OBJECT;
        this.wooOrderDetails = results[0];
        this.shipstationOrderDetails = results[1];
      }
    },
    getStampsTrackingInfo: function (trackingNumber) {
      this.trackingNumber = trackingNumber;
      axios.get(appConstants.STAMPS_COM_BASE_URL+trackingNumber)
      .then((response) => {
        this.wooOrderDetails.live_status_update = 'USPS: '+response.data.status_description;
        if (response.data.status_description.toLocaleLowerCase() == appConstants.ORDER_STATUS.DELIVERED.toLocaleLowerCase()) {
          this.wooOrderDetails.date_delivered = response.data.events[0].carrier_occurred_at;
          this.generateTimelineData(this.wooOrderDetails, appConstants.ORDER_STATUS.DELIVERED);
        }
      })
    },
    getFedexTrackingInfo: function (trackingNumber) {
      this.trackingNumber = trackingNumber;
      var bodyFormData = new FormData();
      bodyFormData.append('bodyData','{ "includeDetailedScans": true, "trackingInfo": [ {"trackingNumberInfo": { "trackingNumber": "'+trackingNumber+'"} } ] }');
      bodyFormData.append('token', this.fedexAccessToken);
      axios({
        method: "POST",
        url: appConstants.FEDEX_BASE_URL+'?op=get_tracking_details',
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        this.wooOrderDetails.live_status_update = 'FEDEX: '+response.data.output.completeTrackResults[0].trackResults[0].latestStatusDetail.description;
        if (response.data.output.completeTrackResults[0].trackResults[0].latestStatusDetail.description.toLocaleLowerCase() == appConstants.ORDER_STATUS.DELIVERED.toLowerCase()) {
          this.wooOrderDetails.date_delivered = response.data.output.completeTrackResults[0].trackResults[0].scanEvents[0].date;
          this.generateTimelineData(this.wooOrderDetails, appConstants.ORDER_STATUS.DELIVERED);
        }
      });
    },
  },
  beforeMount() {
    this.selectedOrderId = this.useRouter.currentRoute._value.params.orderId;
    this.loadedOrderDetails = this.orderListStorage.data.orders.filter((order) => order.order_id == this.selectedOrderId)[0];
    this.selectedOrderNumber = this.loadedOrderDetails.order_number;
  },
  mounted() {

    this.timelineData = [];
    this.lineItems = [];
    this.wooOrderDetails = null;
    this.shipstationOrderDetails = null;

    if (this.providedVins) {
      if (this.providedVins.length) {
        this.orderVin = this.providedVins[0].vin;
      }
    }
    
    if (this.currentOrderDetails) {
      if (this.selectedOrderId == this.currentOrderDetails.id) {
        this.timelineData = [];
        this.wooOrderDetails = this.currentOrderDetails;
        this.shipstationOrderDetails = this.currentShipstationDetails;
        this.afterComplete(this.currentOrderDetails)
        this.toggleFullScreenSpinner(false);
      } else {
        this.refreshOrder();
      }
    } else {
      this.refreshOrder();
    }


  }
});
</script>
